export default __webpack_public_path__ + "static/media/5.ed00a16b.png";